import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})


api.interceptors.request.use(async (config) => {

  try {
    const authStore = useAuthStore()
    if (authStore.localTokens.access_token) {
      await authStore.updateToken()
      config.headers.Authorization = `Bearer ${authStore.localTokens.access_token}`
      return config
    }
  } catch (error) {
    console.warn('Could not access auth store, falling back to localStorage', error)
  }
  
  return config
})


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        const authStore = useAuthStore()
        if (authStore.isAuthenticated) {
          await authStore.logout()
        }
      } catch (error) {
        console.warn('Could not access auth store during 401 handling', error)
      }
    }
    return Promise.reject(error)
  }
)

export default api 